import * as React from 'react';

import * as styles from './NewBadge.css';

type TNewBadgeProps = {
  dataName: string;
};

/**
 * Красная точка «новое» в правом верхнем углу родителя с position: relative.
 */
export const NewBadge: React.FC<TNewBadgeProps> = ({ dataName }) => {
  return <span className={styles['badge']} data-name={dataName} />;
};
